@use '~/theme/theme' as *;

.container {
  align-items: center;
  border-radius: spacing(1);
  box-shadow: 0 2px 8px 0 rgb(0 0 0 / 16%);
  display: flex;
  gap: spacing(2);
  height: 56px;
  padding: spacing(2);
  background-color: var(--toast-background);
  view-transition-class: toast;
}

@keyframes slide-in {
  from {
    opacity: 0;
    transform: translateY(20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slide-out {
  from {
    opacity: 1;
    transform: translateY(0);
  }

  to {
    opacity: 0;
    transform: translateY(20px);
  }
}

::view-transition {
  pointer-events: none;
}

::view-transition-new(.toast):only-child {
  animation: slide-in 0.2s ease-out forwards;
}

::view-transition-old(.toast):only-child {
  animation: slide-out 0.2s ease-in forwards;
}

.content {
  display: flex;
  gap: spacing(1.5);
  align-items: center;
}

.icon {
  @include icon-size(sm);

  flex-shrink: 0;
}

.default {
  --toast-background: #{color(grey-100)};
}

.info {
  --toast-background: #{color(violet-100)};
}

.infoIcon {
  color: #{color(violet-600)};
}

.warning {
  --toast-background: #{color(orange-100)};
}

.warningIcon {
  color: #{color(orange-800)};
}

.error {
  --toast-background: #{color(lobster-100)};
}

.errorIcon {
  color: #{color(lobster-800)};
}

.success {
  --toast-background: #{color(green-100)};
}

.successIcon {
  color: #{color(forest-700)};
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.loadingIcon {
  animation: spin 1s linear infinite;
  color: #{color(violet-600)};
}
